<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {boolean} is user selected to agree the terms
   */
  let isTermsAgreed = false

  let disableBtn = false
</script>

<div class="relative w-full max-w-[650px] overflow-hidden rounded-md bg-white text-left">
  <div class="flex h-full w-full transform select-none flex-col break-all bg-white from-[#3f3f3f] to-black text-left transition-all dark:bg-gradient-to-tl mobile:flex-row md:m-0">
    <div class="via-75% hidden h-full w-[10%] items-center justify-center bg-gradient-to-r from-[#FF6A00] via-[#F8A500] to-[#FF8000] text-white mobile:flex">
      <h1 class="vertical-text font-bold">INSTRUCTIONS</h1>
    </div>
    <div class=" via-75% flex h-20 w-full items-center justify-center bg-gradient-to-r from-[#FF6A00] via-[#F8A500] to-[#FF8000] p-3 text-white mobile:hidden">
      <h1 class="text-2xl font-bold tracking-widest">INSTRUCTIONS</h1>
    </div>
    <div class="flex h-full w-full flex-col justify-between p-3 mobile:w-[90%] mobile:p-9">
      <ul class="instruct wordBreak w-full px-6 leading-loose dark:text-white">
        <li class="w-full mobile:break-words">
          Please ensure that you do not change the name of the <strong>TEMPLATE FILE</strong>
          . Edit and upload it exactly as it is.
        </li>
        <li>
          The columns named as <strong>RECEIVER_NAME , DOCUMENT_TYPE , ISSUER_SIGNATORY</strong>
          must be filled for all entries.
        </li>
        <li>
          If you choose to upload files, the <strong>FILENAME</strong>
          column must be filled for all entries.
        </li>
        <li>
          The filenames must include their respective <strong>FILE TYPES</strong>
          too. e.g., file1.png, file2.jpg, file3.jpeg
        </li>
        <li>
          Dates must be in any one of the following formats, and cell format <strong>must be general or text</strong>
          .
        </li>
        <li class="innerlist">DD/MM/YYYY e.g., 30/06/2020</li>
        <li class="innerlist">DD-MM-YYYY e.g., 30-06-2020</li>
        <li>
          Expiry is <strong>Optional</strong>
          , it takes in the date the document expires, leave blank if no expiry
        </li>
        <li>
          Edit the downloaded .xlsx file using any spreadsheet software, such as <a href="https://docs.google.com/spreadsheets/" target="_blank" class="font-bold text-blue-500 underline underline-offset-4">Google Sheets</a>
          ,
          <a href="https://www.libreoffice.org/download/download-libreoffice/" target="_blank" class="font-bold text-blue-500 underline underline-offset-4">LibreOffice</a>
          ,
          <strong>Microsoft Office</strong>
          , etc.
        </li>
      </ul>

      <div>
        <div class="mt-3 mb-12 flex items-center gap-3">
          <input id="terms" type="checkbox" bind:checked={isTermsAgreed} class="h-6 w-6 rounded-md" />
          <label for="terms" class="cursor-pointer text-base font-medium text-gray-500 dark:text-slate-400">I agree to the terms mentioned above.</label>
        </div>

        <div class="flex w-full items-center justify-between">
          <button on:click type="button" class="flex h-9 w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-2 text-sm font-medium text-gray-900 focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-bodyblack md:w-32 lg:px-4">
            <span>
              <i class="fa-solid fa-circle-xmark" />
            </span>
            <span class="hidden select-none md:block">&nbsp;&nbsp;Close&nbsp;</span>
          </button>

          <button
            disabled={!isTermsAgreed || disableBtn}
            on:click={() => {
              disableBtn = true
              dispatch("download")
            }}
            type="button"
            class="disabled:text-white-200/50 flex h-9 min-w-[52px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-gray-200/50 lg:px-4"
          >
            <span>
              <i class="fa-solid fa-circle-check" />
            </span>
            <span class="hidden select-none md:block">&nbsp;&nbsp;Confirm&nbsp;and&nbsp;Download&nbsp;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  strong {
    @apply text-blue-500;
  }
  .instruct li {
    @apply list-disc text-gray-900 dark:text-slate-400;
  }
  .innerlist {
    @apply list-inside pl-3;
  }
  .vertical-text {
    text-indent: 20px;
    font-size: 39px;
    letter-spacing: 27px;
    writing-mode: vertical-lr;
    /* text-orientation: upright; */
    rotate: 180deg;
  }
</style>
